/* eslint-disable no-bitwise */

export class EnumFlagsService{

    private names: string[] = [];
    private numbers: number[] = [];
    private namesDictionary: Map<number, string> = new Map<number, string>();
    private numbersDictionary: Map<string, number> = new Map<string, number>();

    constructor(
        private keyValues: EnumFlagKeyValue[]
    ){
        keyValues.forEach(n => {
            this.names.push(n.name);
            this.numbers.push(n.value);
            this.namesDictionary.set(n.value, n.name);
            this.numbersDictionary.set(n.name, n.value);
        });
    }

    public getValue(names: string[]): number{
        let result = 0;
        names.forEach(n => result = result +  this.nameToValue(n));
        return result;
    };

    public getNames(value: number): string[]{
        const result = new Array<string>();

        this.numbers.forEach(n => {
            if((n & value) !== 0){
                result.push(this.valueToName(n));
            }
        });

        return result;
    }

    public getAllNames(): string[]{
        return this.names;
    }

    private nameToValue(name: string): number {
        return this.numbersDictionary.get(name) as number;
    }

    private valueToName(value: number): string {
        return this.namesDictionary.get(value) as string;
    }
}

export class EnumFlagKeyValue{

    constructor(
        public name: string,
        public value: number
    ){}
}
